import { render } from "./MypageMenu.vue?vue&type=template&id=99b02904&scoped=true"
import script from "./MypageMenu.vue?vue&type=script&lang=js"
export * from "./MypageMenu.vue?vue&type=script&lang=js"

import "./MypageMenu.vue?vue&type=style&index=0&id=99b02904&scoped=true&lang=css"

import exportComponent from "D:\\作業\\GitlabWebシステム\\ｱ_青森市社会福祉協議会_Webボランティアシステム\\Web-Volunteer-Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99b02904"]])

export default __exports__